import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 THE AGE-IN-PLACE BLUEPRINT™',
  ideal: 'Professional caregivers and families who want to keep aging parents safe, healthy and independent at home without expensive residences',
  was: '$54',
  now: '$27',
  features: ['6 Complete Volumes (200+ pages)', 'Cognitive Health, Strength, Nutrition, Safety & Caregiver Wellness protocols', 'Real aging-in-place frameworks', '30-Day routine with visible progress', '5 Free Bonuses included', '7-Day Money-Back Guarantee'],
  cta: 'Get The Age-in-Place Blueprint™'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-149" data-mp="3vz71w0ckytr2">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-150" data-mp="4rb1m1ab9lvj">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(29,78,216,0.45)]" style={{
        paddingTop: "5px",
        paddingBottom: "5px"
      }} data-id="element-151" data-mp="9qe5vjigvo2g">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-152" data-mp="3rywwaospa5cq">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-153" data-mp="2uizj1lyxk0k4">
            <span className="font-semibold text-plum/80" data-id="element-154" data-mp="2ugdbhmc1hl1w">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-155" data-mp="2zfg6edyb2aw5">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "20px"
          }} data-id="element-156" data-mp="2rglansogvt93">{plan.was}</span>
            <div className="text-grape-shine font-display text-4xl font-black" style={{
            fontSize: "64px",
            paddingBottom: "26px",
            fontFamily: "Montserrat, sans-serif",
            paddingTop: "20px"
          }} data-id="element-157" data-mp="2mh09dbltr8t7">{plan.now}</div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-158" data-mp="2w9o3fylf6yo8">
              One-time payment · Lifetime access
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-159" data-mp="23j5vok9r494h">
              Payment will be processed in your local currency.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-160" data-mp="2ie3n9ax2suki">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-161" data-mp="2dfscmxyyig18">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-162" data-mp="3ttsb04i5lxmd" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-163" data-mp="anbqg8144pr">
            <CTAButton size="md" data-id="element-164" data-mp="92g0n9zafqb">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-165" data-mp="5ai12fc5om8p">
            You save $27 USD (50% OFF)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-166" data-mp="3nh66k6b4bbew">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-167" data-mp="j1eto66313fr">
                <Icon className="h-4 w-4 text-grape" data-id="element-168" data-mp="nyws32mh409i" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-169" data-mp="a8b97dx0rqbm" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-170" data-mp="ea54f6og424e">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-171" data-mp="11yxsyi2qn7oz" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-172" data-mp="16qzfcwtmeesq">
            <span className="font-display font-bold text-plum" data-id="element-173" data-mp="16saj4wn2fmju">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel the ebook does not match what you need or does not
            give you the peace of mind you were looking for, request your refund and we return 100%
            of your money. We want you to age your parent in place with confidence, risk-free.
          </p>
        </div>
      </div>
    </section>;
}